import React from 'react'
import { useNavigate } from 'react-router-dom'

import { Link, useNavbarState } from '@affstore-ds/uikit'

import { handleNavigate } from '../../../../shared/navigation/handleNavigate'
import { routes } from '../../../../shared/routes'
import { LevelBadgeView } from '../../components/LevelBadgeView'
import { getLevelTranslationKey } from '../../lib/utils/getLevelTranslationKey'

import { useLoyaltyLevels } from '../../model/useLoyaltyLevels'

export const LevelBadge = () => {
  const navigate = useNavigate()
  const { currentLevel, loading } = useLoyaltyLevels()
  const { closeMobileNavbar } = useNavbarState()

  if (loading || !currentLevel || !getLevelTranslationKey(currentLevel.name)) {
    return <LevelBadgeView levelName={currentLevel?.name} loading={loading} />
  }

  return (
    <Link href={routes.ROUTES_LOYALTY_PROGRAM.root} onClick={handleNavigate(navigate, routes.ROUTES_LOYALTY_PROGRAM.root, closeMobileNavbar)}>
      <LevelBadgeView levelName={currentLevel.name} />
    </Link>
  )
}
